import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { SellerHistoryQueryKeys } from "./keys";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ISellerSoldHistory } from "../../models/SellerHistory/SellerSoldHistory";

export default function useSellerHistory(seller: string, enabled: boolean = true) {
  const { get } = useApiHelper();

  const normalized = (seller || "").trim();

  const history = useQuery({
    queryKey: SellerHistoryQueryKeys.forSeller(normalized.toLowerCase()),
    queryFn: () =>
      get<IDefaultResponse<ISellerSoldHistory[]>>(
        `/sellerhistory?seller=${encodeURIComponent(normalized)}`
      ).then((res) => res.data),
    enabled: enabled && normalized.length > 0,
  });

  return {
    history,
  };
}
